const React = require("react");

function ExternalLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
  }));
}

module.exports = ExternalLinkIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/ExternalLinkIcon.js
 ** module id = 523
 ** module chunks = 0
 **/